module.exports = __webpack_public_path__ + "static/real_matter-f7b1bf3ac77e165b4c34581af2613529.png";